export default class MemoryContext {
    static components: {} = {}
}